export const CREATE_ONG = "CREATE_ONG"
export const CREATE_ONG_SUCCESS = "CREATE_ONG_SUCCESS"
export const CREATE_ONG_API_ERROR = "CREATE_ONG_API_ERROR"


export const GET_POSTAL_CODE = "GET_POSTAL_CODE"
export const GET_POSTAL_CODE_SUCCESS = "GET_POSTAL_CODE_SUCCESS"
export const GET_POSTAL_CODE_API_ERROR = "GET_POSTAL_CODE_API_ERROR"